import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="site-footer">
      <div className="footer-brand">SortMyBusiness<span>AI</span></div>
      <ul className="footer-links">
        <li><a href="#">Privacy Policy</a></li>
        <li><a href="#">Terms</a></li>
        <li><a href="#cta">Book a Call</a></li>
        <li><a href="mailto:hello@sortmybusinesswithai.com">hello@sortmybusinesswithai.com</a></li>
      </ul>
      <span className="footer-copy">&copy; 2026 Sort My Business With AI</span>
    </footer>
  );
};

export default Footer;
